var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5406 5.1125C15.9548 5.69852 15.6257 6.49323 15.6257 7.32187C15.6257 8.15051 15.9548 8.94522 16.5406 9.53125L32.0094 25L16.5406 40.4687C15.9714 41.0581 15.6564 41.8475 15.6635 42.6669C15.6706 43.4862 15.9993 44.27 16.5787 44.8494C17.1581 45.4288 17.9419 45.7575 18.7612 45.7646C19.5806 45.7717 20.37 45.4567 20.9594 44.8875L38.6375 27.2094C39.2233 26.6234 39.5525 25.8286 39.5525 25C39.5525 24.1714 39.2233 23.3766 38.6375 22.7906L20.9594 5.1125C20.3734 4.52665 19.5786 4.19754 18.75 4.19754C17.9214 4.19754 17.1267 4.52665 16.5406 5.1125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5406 5.1125C15.9548 5.69852 15.6257 6.49323 15.6257 7.32187C15.6257 8.15051 15.9548 8.94522 16.5406 9.53125L32.0094 25L16.5406 40.4687C15.9714 41.0581 15.6564 41.8475 15.6635 42.6669C15.6706 43.4862 15.9993 44.27 16.5787 44.8494C17.1581 45.4288 17.9419 45.7575 18.7612 45.7646C19.5806 45.7717 20.37 45.4567 20.9594 44.8875L38.6375 27.2094C39.2233 26.6234 39.5525 25.8286 39.5525 25C39.5525 24.1714 39.2233 23.3766 38.6375 22.7906L20.9594 5.1125C20.3734 4.52665 19.5786 4.19754 18.75 4.19754C17.9214 4.19754 17.1267 4.52665 16.5406 5.1125Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.0b146d57eb5152768d832e0e1c0705ee.svg";
export { ForwardRef as ReactComponent };